export default "__VITE_ASSET__DVnIVGVu__"